import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelected('');
    }
  };

  return (
    <section className="w-full bg-background-100 py-10">
      <div className="max-w-2xl mx-auto px-6 md:px-10">
        <label htmlFor="category-select" className="block text-sm font-medium text-foreground-600 mb-3 text-center">
          Quick Category Navigation
        </label>
        <div className="relative">
          <select
            id="category-select"
            value={selected}
            onChange={handleChange}
            className="w-full appearance-none bg-background-50 border border-background-200 rounded-full px-5 py-3.5 pr-12 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
          >
            <option value="" disabled>
              Select a category to explore...
            </option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}